// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"switch-button_wrapper__2SqJl","switch_box":"switch-button_switch_box__desLV","box_1":"switch-button_box_1__2mrDZ","switch_1":"switch-button_switch_1__W19DF"};